import { render, staticRenderFns } from "./addMainContact.vue?vue&type=template&id=475fd153&lang=pug"
import script from "./addMainContact.vue?vue&type=script&lang=js"
export * from "./addMainContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports